var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-6 px-2 py-1 leading-none absolute rounded-full bg-gray-500 text-sm text-gray-900 font-semibold badge-centered"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }